'use client'

import React from 'react'
import { Eyebrow } from '@/components/Eyebrow'
import { Subheading } from '@/components/ui/subheading'
import { cn } from '@/utilities/ui'
import { Color } from '@/utilities/colors'
import RichText from '@/components/RichText'
import { RichTextType } from '@/utilities/types'
import { Text } from '@/components/ui/text'

export const EyebrowItem: React.FC<{
  color: Color
  label: string
  description?: RichTextType | string
  children?: React.ReactNode
  className?: string
}> = ({ label, color, description, children, className }) => {
  return (
    <div className={cn('flex items-start gap-[20px]', className)}>
      <div className="pt-2">
        <Eyebrow color={color} variant="dark" />
      </div>
      <div className="flex flex-col gap-2">
        <Subheading size="md">{label}</Subheading>
        {description && typeof description === 'string' && <Text size="lg">{description}</Text>}
        {description && typeof description !== 'string' && <RichText data={description} />}
        {children}
      </div>
    </div>
  )
}
